module.exports = __webpack_public_path__ + "img/vip-banner-bg.cee082d5.png";